import React, { useState, useRef, useEffect, Suspense } from 'react';
import { Box, Grid, Text, Flex, Image } from '@chakra-ui/react';
import { MdToken } from 'react-icons/md';

const TokensRoad = ({ 
  sessionTokens, 
  setSessionTokens,
  speed, 
  movingBoxesOpacity,
  roadRotateZ,
  roadPositionX,
  rotateRoadScale,
  stationaryBoxRef
}) => {
  const movingBoxRef = useRef(null);
  const [movingBoxes, setMovingBoxes] = useState([]);
  const [floatingTexts, setFloatingTexts] = useState([]);

  const createNewBox = () => {
    const left = Math.random() * (60 - 40) + 40; 
    const id = Date.now(); 
    setMovingBoxes((prev) => [
      ...prev,
      { id, left: `${left}%`, top: 0, opacity: 0 }, 
    ]);

    setTimeout(() => {
      setMovingBoxes((prev) => prev.filter((box) => box.id !== id));
    }, 5000);
  };

  useEffect(() => {
    let timeout; 
    const randomDelays = [100, 150, 200, 300, 400, 500, 1000];
    const createBoxWithRandomDelay = () => {
      createNewBox(); 
      const randomDelay = randomDelays[Math.floor(Math.random() * randomDelays.length)];
      timeout = setTimeout(createBoxWithRandomDelay, randomDelay);
    };
    createBoxWithRandomDelay();
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    let hasCollision = false;

    if (stationaryBoxRef.current) {
      const stationaryBox = stationaryBoxRef.current.getBoundingClientRect();

      movingBoxes.forEach((box) => {
        const movingBox = document.getElementById(box.id)?.getBoundingClientRect();
        if (movingBox) {
          const isColliding =
            movingBox.left < stationaryBox.right &&
            movingBox.right > stationaryBox.left &&
            movingBox.top < stationaryBox.bottom &&
            movingBox.bottom > stationaryBox.top;

          if (isColliding) {
            hasCollision = true;
          }
        }
      });
    }

    if(movingBoxesOpacity === 1){
      if (hasCollision) {
        addTokens(1);

        const id = Date.now(); 
        const left = Math.random() * 90; 
        const top = Math.random() * 90; 

        setFloatingTexts((prev) => [
          ...prev,
          { id, text: "+1", left: `${left}%`, top: `${top}%` },
        ]);

        setTimeout(() => {
          setFloatingTexts((prev) => prev.filter((item) => item.id !== id));
        }, 1000);
      } 
    }
  }, [movingBoxes]);

  const addTokens = (newTokens) => {
    const setNewTokens = parseInt(sessionTokens, 10) + newTokens;
    setSessionTokens(setNewTokens);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setMovingBoxes((prev) =>
        prev
          .map((box) => {
            if (box.top >= 100) return null;
            return { ...box, top: box.top + 5, opacity: box.top >= 2 && box.top < 5  ? 0.4 : box.top >= 5 ? 1 : 0  };
          })
          .filter(Boolean)
      );
    }, 50);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Box 
        position="absolute" 
        h="110px"
        bottom="43%"
        w="40%"
        zIndex="1"
        overflow="visible"
        right="30%">
        { floatingTexts.map((item) => (
          <Text
            overflow="visible"
            key={item.id}
            position="absolute"
            left={item.left}
            top={item.top}
            fontSize="30px"
            fontWeight="bold"
            color="rgb(35 5 14)"
            style={{
              animation: "fadeToken 1s ease-out, neonFlicker 1.5s infinite",
              textShadow: `
                rgb(221, 22, 80) 0px 0px 2px, 
                rgb(221, 22, 80) 0px 0px 4px, 
                rgb(221, 22, 80) 0px 0px 4px`,
            }}
          >
            +
            <MdToken fontSize="55px" color="rgb(221, 22, 80)" style={{marginTop: '-30px', marginLeft: '15px'}} />
          </Text>
        ))}
      </Box>

      <Grid 
        className="road"
        position="absolute"
        top="0"
        templateColumns="repeat(2, 1fr)" 
        transform={`
          perspective(270px) 
          rotateX(60deg) 
          rotateZ(${roadRotateZ}deg)
          translateX(${roadPositionX}px) 
          scale(${rotateRoadScale}) 
          translateY(-112px)`}>
        <Box></Box>
        <Box>
          <Box
            className="road-strip"
            style={{
              backgroundImage: 'unset', //`linear-gradient(to bottom, transparent 0px, transparent 5px), url(${roadLine})`,
              animationDuration: `${speed}s`,
            }} />
        </Box>

        <Box position="absolute" w="100%" h="100vh" opacity={movingBoxesOpacity}>
        { movingBoxes.map((box) => (
          <Box
            ref={movingBoxRef}
            key={box.id}
            id={box.id}
            position="absolute"
            w="17px"
            h="18px"
            borderRadius="50%"
            transition="0.3s all"
            style={{
              top: `${box.top}%`, 
              left: box.left,
              opacity: box.opacity
            }}
            bg="transparent"
          >
            <MdToken fontSize="18px" color="#dd1650" />
          </Box>
        ))}
        </Box>
        
      </Grid>

    </>
  );
};

export default TokensRoad;